<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    status?: "pending" | "approved" | "rejected"
  }>(),
  {
    status: "pending",
  },
)

const pingColors = {
  pending: {
    outer: "bg-yellow-500/20",
    inner: "bg-yellow-500",
  },
  approved: {
    outer: "bg-green-500/20",
    inner: "bg-green-500",
  },
  rejected: {
    outer: "bg-red-500/20",
    inner: "bg-red-500",
  },
}
</script>

<template>
  <div
    class="flex aspect-square size-4 items-center justify-center rounded-full"
    :class="[pingColors[status].outer]"
  >
    <span
      class="aspect-square size-2 rounded-full"
      :class="pingColors[status].inner"
    />
  </div>
</template>
